// External deps
import { useContext } from 'react';

// Internal deps
import { UserPermisionsContext} from '../context/UserPermisionsContext';

export default function useUserPermisions() {
  return useContext(UserPermisionsContext);
}